import i18n from 'i18next'
import { enCA, fr } from 'date-fns/locale';
import { reactI18nextModule } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

//Language File
import callList_fr from "./common/translations/fr/callList.json";
import callList_en from "./common/translations/en/callList.json";
import common_fr from "./common/translations/fr/common.json";
import common_en from "./common/translations/en/common.json";
import hcScheduleReport_en from './common/translations/en/hcScheduleReport.json';
import hcScheduleReport_fr from './common/translations/fr/hcScheduleReport.json';
import quotaManagement_en from './common/translations/en/quotaManagement.json'
import quotaManagement_fr from './common/translations/fr/quotaManagement.json'
import workplanManager_fr from "./common/translations/fr/workplanManager.json";
import workplanManager_en from "./common/translations/en/workplanManager.json";
import requestCalendar_fr from './common/translations/fr/requestCalendar.json';
import requestCalendar_en from './common/translations/en/requestCalendar.json';
import dailyShiftBidding_fr from './common/translations/fr/dailyShiftBidding.json';
import dailyShiftBidding_en from './common/translations/en/dailyShiftBidding.json';
import vacationBidding_fr from './common/translations/fr/vacationBidding.json';
import vacationBidding_en from './common/translations/en/vacationBidding.json';
import shiftBidding_fr from './common/translations/fr/shiftBidding.json';
import shiftBidding_en from './common/translations/en/shiftBidding.json';
import shiftHistory_fr from './common/translations/fr/shiftHistory.json';
import shiftHistory_en from './common/translations/en/shiftHistory.json';
import menu_fr from './common/translations/fr/menu.json';
import menu_en from './common/translations/en/menu.json';

let locale = enCA;
export const getLocale = () => {
    const selectedLocale = sessionStorage.getItem('selectedLocale');
    return selectedLocale ? selectedLocale : locale;
}

export const setLocale = (isEnglish) => {
    locale = isEnglish ? enCA : fr;
    const selectedLocale = isEnglish ? 'enCA' : 'fr';
    sessionStorage.setItem('selectedLocale', selectedLocale);
};

i18n
    .use(reactI18nextModule)
    .use(LanguageDetector)
    .init({
        interpolation: {
            escapeValue: false
        }, // React already does escaping      
        detection: {
            order: ['localStorage', 'navigator'],
            lookupLocalStorage: 'language'
        },
        resources: {
            en: {
                callList: callList_en,
                common: common_en, // 'common' is our custom namespace
                hcScheduleReport: hcScheduleReport_en,
                workplanManager: workplanManager_en,
                quotaManagement: quotaManagement_en,
                requestCalendar: requestCalendar_en,
                dailyShiftBidding: dailyShiftBidding_en,
                vacationBidding: vacationBidding_en,
                shiftBidding: shiftBidding_en,
                shiftHistory: shiftHistory_en,
                menu: menu_en,
            },
            fr: {
                callList: callList_fr,
                common: common_fr,
                hcScheduleReport: hcScheduleReport_fr,
                workplanManager: workplanManager_fr,
                quotaManagement: quotaManagement_fr,
                requestCalendar: requestCalendar_fr,
                vacationBidding: vacationBidding_fr,
                dailyShiftBidding: dailyShiftBidding_fr,
                shiftBidding: shiftBidding_fr,
                shiftHistory: shiftHistory_fr,
                menu: menu_fr,
            }
        },
        fallbackLng: 'en'
    });

export default i18n